import { createContext, useContext } from "react";
import type { ISubscriptionEditProviderContextValue } from "./SubscriptionEditProvider.types";

export const SubscriptionEditProviderContext = createContext<ISubscriptionEditProviderContextValue>(
  {} as ISubscriptionEditProviderContextValue
);

export function useSubscriptionEditProviderContext() {
  return useContext(SubscriptionEditProviderContext);
}
